/*
    JSON  utilitiy functions.
*/

/**
 * JSON Stringify the specified object with keys sorted ascending.
 * @param {Object} value 
 * @returns JSON stringified object.
 */
const stringifyAsc = (value) => {
    return JSON.stringify(value, replacerAsc);
}
export { stringifyAsc };

/**
 * JSON Stringify Replacer to sort alphabetically (recursively).
 * @param {String} key 
 * @param {Object} value 
 * @returns Array of sorted keys suitable for the replacer parameter.
 */
const replacerAsc = (key, value) =>
    value instanceof Object && !(value instanceof Array) ?
        Object.keys(value)
            .sort()
            .reduce((sorted, key) => {
                sorted[key] = value[key];
                return sorted
            }, {}) :
        value;
export { replacerAsc };
